import styled from 'styled-components'

export const SortBySelect = styled.div`
  display: flex;
  color: #2b2828;
  align-items: center;

  label {
    font-weight: 500;
  }

  svg {
    fill: #2b2828;
  }

  .sortBy-select-option {
    font-weight: 400;
    &.focused,
    &.selected {
      background: #f8f8f8;
      color: #2b2828;
    }
    &.selected {
      font-weight: 600;
    }
  }

  .sortby-select-container {
    min-width: 180px;
    border: none;
  }

  .sortBy-select-control {
    border: none;

    &.focused {
      box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);
    }
  }

  .sortBy-select-menu {
    top: 90%;
    z-index: 5;
    margin-top: 0;
    box-shadow: 0 1px 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`
